import { configureStore } from "@reduxjs/toolkit";
import { baseAPI } from "./baseService";
import reducer from "./reducer";

export const store = configureStore({
  reducer: {
    router: reducer,
    [baseAPI.reducerPath]: baseAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(
    baseAPI.middleware
  ),
});